module.exports = __webpack_public_path__ + "img/Foto_Strassenbauerin-MS-7794_2019.92993539.jpg";